import { connect } from 'react-redux';

import { SampleAppBar } from '../components/AppBar';
import { StoreState } from '../store/store';

const mapStateToProps = (state: StoreState) => {
    return Object.assign({}, state.viewerState, state.appState);
};

export default connect(mapStateToProps)(SampleAppBar);
